import DOMPurify from 'dompurify';

window.DOMPurify = DOMPurify;

const alpineAttributes = [
    'x-cloak',
    'x-data',
    'x-for',
    'x-get-file',
    'x-get-id',
    'x-get-page',
    'x-get-parameters',
    'x-get-type',
    'x-if',
    'x-model',
    'x-modelable',
    'x-on:click.prevent',
    'x-ref',
    'x-show',
    'x-text',
    'x-trap',
    ':alt',
    ':class',
    ':disabled',
    ':key',
    ':src',
    ':value',
    '@click',
    '@click.outside',
    '@click.prevent',
    '@click.stop',
    '@close-modal',
    '@input',
    '@keydown.enter.prevent',
    '@keyup.enter',
    '@keyup.escape.window',
    '@mouseenter',
    '@mouseleave',
];

// Legacy application actions use this inert URI. Allow only this exact value;
// all other JavaScript URIs remain blocked by DOMPurify.
const dynamicMarkupAllowedUri = /^(?:javascript:void\(0\)$|(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$)))/i;

// AJAX page and popup responses contain application-owned Alpine markup.
window.sanitizeDynamicMarkup = (markup) => DOMPurify.sanitize(markup, {
    ADD_ATTR: alpineAttributes,
    ALLOWED_URI_REGEXP: dynamicMarkupAllowedUri,
});
